<micro-select-combo #sel
              placeholder="Event Type"
              [mode]="mode"
              [(id)]="eventType"
              (idChange)="change($event)"
              [required]="required"
              [options]="options"
              [disabled]="disabled"
>
</micro-select-combo>
